export default __webpack_public_path__ + "static/media/classic_logo_white.2b3efc04.png";